
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.045 1.07a5.987 5.987 0 014.832 9.522l2.802 2.802a.9.9 0 11-1.273 1.273l-2.798-2.799A5.987 5.987 0 117.045 1.07zm0 1.8a4.187 4.187 0 100 8.373 4.187 4.187 0 000-8.373z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    